import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

export type User = {
  id: number;
  username: string;
  email: string;
  token: string;
};

const UserContext = React.createContext<
  Partial<{
    user: User;
    setUser: (user: User) => void;
    setToken: (token: string) => void;
    signout: () => void;
    isSignedIn: () => boolean;
  }>
>({});

const UserContextProvider: React.FC = props => {
  const [user, setUserState] = useState<User>();
  
  useEffect(() => {
    const userCookie = Cookies.get("user");

    if (userCookie) {
      const user = JSON.parse(userCookie);
      setUserState(user);
    }

    return () => {
      if (user) {
        Cookies.set("user", JSON.stringify(user));
      }
    };
  }, []);

  function setUser(user: User) {
    setUserState(user);
    Cookies.set("user", JSON.stringify(user));
  }

  function setToken(token: string) {
    user.token = token;
  }
  function signout() {
    setUser(null);
    Cookies.remove('user');
  }
  function isSignedIn() {
    return Cookies.get("user") != null;
  }

  return (
    <UserContext.Provider
      value={{ user, setUser, setToken, signout, isSignedIn }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;
export { UserContextProvider };
